import BodyText from 'LuxKit/Typography/BodyText'
import React from 'react'
import useExperienceSearch from 'hooks/Experiences/useExperienceSearch'
import ExperienceListTileCarousel from './ExperienceListTileCarousel'

interface Props {
  placeId: string
  placeIdToIgnore?: string
  categories?: Array<number>
  sortBy?: Experiences.SortTypes
  excludeIds?: Array<string>
  className?: string
  limit?: number
  campaigns?: Array<string>
  collections?: Array<string>
}

function ExperienceSearchTileList(props: Props) {
  const { placeId, placeIdToIgnore, categories, sortBy, excludeIds, className, limit = 20, campaigns, collections } = props

  const [list, experiences] = useExperienceSearch({
    placeId,
    placeIdToIgnore,
    sortBy,
    limit,
    excludeIds,
    campaigns,
  }, { categoryCodes: categories, collections })

  const fetching = (!list || list.fetching) && !list?.error

  return <div>
    {list?.error && <BodyText variant="large">Something went wrong!</BodyText>}
    {!fetching && !list?.error && list.ids.length === 0 && <BodyText variant="large">
      No experiences available
    </BodyText>}
    <ExperienceListTileCarousel
      className={className}
      experiences={experiences}
      listFetching={fetching}
    />
  </div>
}

export default ExperienceSearchTileList
